// --------------------------------------------------------------------------
// #TBC - Pictogram and block chart generator
// --------------------------------------------------------------------------
// Author:      Richard Bultitude
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var Handlebars = require('handlebars');

Handlebars.registerHelper('returnItemAtParentIndex', function (data, index) {
    return data[index];
});

module.exports = function () {

    function init(seriesData, axisLabels, dataSetNames) {
        function buildTable(data) {
            var stringHtml = document.getElementById('table-multi-template').innerHTML;
            var template = Handlebars.compile(stringHtml);
            var html = template(data);
            return html;
        }

        var tableData = {
            seriesData: seriesData,
            axisLabels: axisLabels,
            dataSetNames: dataSetNames
        };

        var table = buildTable(tableData);
        return table;
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/charting/charting-table.js
// module id = 238
// module chunks = 0